<template>
  <footer class="footer-block scf-row scf-margin-bottom--4xl">
    <div class="footer-block--inner scf-row__inner">
      <div class="creation-modification">
        <p class="scf-body-s">
          Sergi's portfolio <strong>v1.1c</strong>
        </p>
        <p class="scf-body-s">
          Created using Vue3 on:
          <strong>August, 2022</strong>
          <br />
          Last update on:
          <strong>September, 2025</strong>
        </p>
      </div>
      <div class="contact">
        <p class="scf-text-and-icon scf-body-s">
          <svg
            id="email-icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 40 32"
            xml:space="preserve"
          >
            <path
              d="M34 0L6 0C2.7 0 0 2.7 0 6L0 26C0 29.3 2.7 32 6 32L34 32C37.3 32 40 29.3 40 26L40 6C40 2.7 37.3 0 34 0ZM6 4L34 4C35.1 4 36 4.9 36 6L36 6.825L20 15.725L4 6.825L4 6C4 4.9 4.9 4 6 4ZM34 28L6 28C4.9 28 4 27.1 4 26L4 11.4L19.025 19.75C19.325 19.925 19.65 20 20 20C20.35 20 20.675 19.925 20.975 19.75L36 11.4L36 26C36 27.1 35.1 28 34 28Z"
              fill="#ffffff66"
              fill-rule="nonzero"
              opacity="1"
              stroke="none"
            />
          </svg>
          <a
            href="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#115;&#101;&#114;&#103;&#105;&#46;&#99;&#111;&#108;&#111;&#109;&#101;&#114;&#64;&#105;&#99;&#108;&#111;&#117;&#100;&#46;&#99;&#111;&#109;"
          >
            &#115;&#101;&#114;&#103;&#105;&#46;&#99;&#111;&#108;&#111;&#109;&#101;&#114;&#64;&#105;&#99;&#108;&#111;&#117;&#100;&#46;&#99;&#111;&#109;
          </a>
        </p>
        <p class="scf-text-and-icon scf-body-s">
          <svg
            id="linkedin-icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 504.4 504.4"
            xml:space="preserve"
          >
            <path
              d="M377.6,0.2H126.4C56.8,0.2,0,57,0,126.6v251.6c0,69.2,56.8,126,126.4,126H378c69.6,0,126.4-56.8,126.4-126.4V126.6
    C504,57,447.2,0.2,377.6,0.2z M168,408.2H96v-208h72V408.2z M131.6,168.2c-20.4,0-36.8-16.4-36.8-36.8c0-20.4,16.4-36.8,36.8-36.8
    c20.4,0,36.8,16.4,36.8,36.8C168,151.8,151.6,168.2,131.6,168.2z M408.4,408.2H408h-60V307.4c0-24.4-3.2-55.6-36.4-55.6
    c-34,0-39.6,26.4-39.6,54v102.4h-60v-208h56v28h1.6c8.8-16,29.2-28.4,61.2-28.4c66,0,77.6,38,77.6,94.4V408.2z"
              fill="#ffffff66"
              fill-rule="nonzero"
              opacity="1"
              stroke="none"
            />
          </svg>
          <a
            href="https://www.linkedin.com/in/sergi-colomer-ferrer/"
            title="link to my Linkedin page"
            target="_blank"
          >
            Linkedin
          </a>
        </p>
        <p class="scf-text-and-icon scf-body-s">
          <svg
            id="linkedin-icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            xml:space="preserve"
          >
            <path
              d="M150 0C67.1573 0-1.56113e-05 67.1573 0 150L0 362C1.01725e-05 444.843 67.1573 512 150 512L165.094 512C165.42 506.986 167.304 499 177 499C190 499 193 493 193 487L192 437C121 453 106 409 106 409C94 379 78 372 78 372C54 356 79 356 79 356C105 358 119 382 119 382C141 421 178 410 193 404C195 387 202 376 209 369C152 363 93 341 93 243C93 215 103 192 119 174C116 168 108 142 122 107C122 107 143 100 192 133C234 121 278 121 320 133C369 100 390 107 390 107C404 142 396 168 393 174C409 192 419 215 419 243C419 341 359 363 302 369C312 377 320 393 320 417L319 487C319 493 322 499 335 499C344.696 499 346.58 506.986 346.906 512L362 512C444.843 512 512 444.843 512 362L512 150C512 67.1573 444.843 3.63216e-06 362 0L150 0ZM346.906 512L165.094 512C164.949 514.226 165 516 165 516L347 516C347 516 347.051 514.226 346.906 512Z"
              fill="#ffffff66"
              fill-rule="nonzero"
              opacity="1"
              stroke="none"
            />
          </svg>
          <a
            href="https://github.com/Lladruc37"
            title="link to my GitHub page"
            target="_blank"
          >
            GitHub
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBlock",
};
</script>

<style lang="less" scoped>
@import "../styles/all.less";
.footer-block {
  margin: @scf-space-xl auto;
}
.footer-block--inner {
  display: flex;
  flex-direction: column;
  gap: @scf-space-sm; // 20px;

  @media @scf-breakpoints--m {
    flex-direction: row;
  }
}
.creation-modification {
  border: 1px solid @white-20;
  border-radius: @scf-border-radius;
  padding: 20px;
  flex: 2;
}
.contact {
  border: 1px solid @white-20;
  border-radius: @scf-border-radius;
  padding: @scf-space-sm;
  flex: 1;
}
#email-icon,
#linkedin-icon,
#github-icon {
  width: @scf-space-m;
  margin-inline-end: @scf-space-2xs; //8px;
}
</style>
